// removed by extract-text-webpack-plugin
module.exports = {"main":"Chart-main--2iQLq","title":"Chart-title--1uhCl","crosshair":"Chart-crosshair--1D8Lm","value":"Chart-value--3ecMu","sharedTriangleLogic":"Chart-sharedTriangleLogic--oBdUV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DataPanel/Details/Chart/Chart.scss
// module id = rFqV
// module chunks = 4